const mediaItems = [
  {
    id: 1,
    title: '《斗破苍穹》动画PV首发',
    desc: '萧炎踏上修炼之路，三年之约即将到来！年度最期待国漫改编，制作精良画面炸裂。',
    src: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20fantasy%20illustration%20with%20a%20young%20warrior%20in%20flowing%20robes%20surrounded%20by%20flames%20and%20energy%2C%20dramatic%20composition%2C%20warm%20orange%20and%20gold%20tones%2C%20clean%20illustration%20style%2C%20no%20text&width=800&height=450&seq=media-comic-01&orientation=landscape',
    tag: '国漫',
    time: '3天前',
  },
  {
    id: 2,
    title: '《咒术回战》最终章速报',
    desc: '虎杖与宿傩的终极对决！芥见下下老师倾力绘制的震撼结局不容错过。',
    src: 'https://readdy.ai/api/search-image?query=Intense%20Japanese%20manga%20style%20battle%20scene%20with%20dark%20atmosphere%20and%20explosive%20energy%20effects%2C%20two%20powerful%20characters%20facing%20off%2C%20dramatic%20lighting%2C%20warm%20amber%20accents%2C%20clean%20illustration&width=800&height=450&seq=media-comic-02&orientation=landscape',
    tag: '日漫',
    time: '1周前',
  },
  {
    id: 3,
    title: '《我独自升级》第二季热播',
    desc: '程肖宇觉醒暗影君主之力，全球猎人排名飙升！韩漫天花板级作品动画化。',
    src: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20shadow%20warrior%20with%20purple%20and%20dark%20blue%20energy%20aura%2C%20mysterious%20gates%20and%20monsters%20in%20the%20background%2C%20clean%20digital%20art%20style&width=800&height=450&seq=media-comic-03&orientation=landscape',
    tag: '韩漫',
    time: '2天前',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精彩视频速递</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            热门漫画改编动画PV、作者访谈、漫展现场直击，一站式掌握最新动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.src}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-foreground-950 group-hover:text-background-50 text-2xl ml-0.5 transition-colors"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed mb-3">{item.desc}</p>
                <span className="text-foreground-400 text-xs">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}